import InvoicesPage from 'features/orderManagement/InvoicesPage';

export function InvoicesContent() {
  return <InvoicesPage pageHeader="Invoices" useHeaderDivider={false} showHeaderElipsis={false} />;
}
